import { OrderPhaseFooterCommandBase } from '@app/shared/components';
import { FinishPhaseService } from '@app/modules/finish-phase/services';
import { LoadingNotificationService } from 'chronos-shared';
import { finalize } from 'rxjs/operators';
import { notificationTopic } from '@app/shared/utils';

export class ConfirmCheckboxCommand implements OrderPhaseFooterCommandBase {
  public enabled = true;
  public buttonText: string;
  public required = false;
  public route: string;
  public loadingTopic = notificationTopic.footerNextFinishPhase;

  constructor(private finishPhaseService: FinishPhaseService) {}

  public execute(): void {
    LoadingNotificationService.publish(this.loadingTopic, true);
    this.finishPhaseService
      .changeKpiConfirmation(this.enabled)
      .pipe(
        finalize(() => {
          LoadingNotificationService.publish(this.loadingTopic, false);
        })
      )
      .subscribe({
        error: () => (this.enabled = !this.enabled)
      });
  }

  public setNavigationParams(route: string): void {
    this.route = route;
  }
}
